import React from 'react'

export function GoogleAnalyticsHead(props) {
  const gaTrackingId = props.config.GA_TRACKING_ID
  const gaOptimizeContainerId = props.config.GA_OPTIMIZE_CONTAINER_ID
  const viewer = props.currentUser

  // facebook経由で登録かつ、リファラがfacebookの認証系のURLだった場合、リファラを消す
  let facebookGATag = ''
  if (viewer && viewer.provider === 'facebook') {
    facebookGATag = `
      if (document.referrer !== "" && sessionStorage.facebookLoginFlag == 1) {
        ga('set', 'referrer', null);
        sessionStorage.removeItem('facebookLoginFlag');
      }
     `
  }

  let dimension1Value = 'not logged in'
  if (viewer) {
    dimension1Value = 'logged in'
  }
  const dimension1ValueGATag = `ga('set', 'dimension1', '${dimension1Value}');`

  let dimension2Value = 'not logged in'
  if (viewer && viewer.owners.results.length > 0) {
    dimension2Value = 'logged in'
  }
  const dimension2ValueGATag = `ga('set', 'dimension2', '${dimension2Value}');`

  let sentUidGATag = ''
  if (viewer) {
    sentUidGATag = `ga('set', '&uid', ${viewer.id});`
  }

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
      <!-- Google Analytics -->
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

      ga('create', '${gaTrackingId}', 'spacemarket.com');
      ga('require', 'displayfeatures');
      ga('require', 'linkid');
      ga('set', 'transport', 'beacon');
      ga('require', 'ec');
      ga('require', '${gaOptimizeContainerId}');
      ${facebookGATag}
      ${dimension1ValueGATag}
      ${dimension2ValueGATag}
      ga('send', 'pageview');
      ${sentUidGATag}
      <!-- Analytics -->
    `,
      }}
    />
  )
}

export function GoogleAnalyticsHeadSecond(props) {
  const gaOptimizeContainerId = props.config.GA_OPTIMIZE_CONTAINER_ID

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
      (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
      h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
      (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
      })(window,document.documentElement,'async-hide','dataLayer',4000,
      {'${gaOptimizeContainerId}':true});

    `,
      }}
    />
  )
}

export function GoogleAnalyticsHeadStyle(props) {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
      .async-hide { opacity: 0 !important}
    `,
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/shared/GoogleAnalytics.jsx